import * as React from 'react'

import type { NextPage } from '@grandvisionhq/next'
import { compose } from '@grandvisionhq/utils'
import { Page } from '@grandvisionhq/www-next/pages/my-account/login'

import withCms from '../../../cms/with-cms'
import withLayout from '../../../cms/with-layout'
import { withCart } from '../../../components/hocs/with-cart'

import '@grandvisionhq/my-account/dist/index.css'

const LoginPage: NextPage = () => {
  const richText = `
  <h3>Sie haben noch kein Kundenkonto?</h3>
  <h4>Kundenkonto anlegen und von vielen Vorteilen profitieren:</h4>
  <ul class="checkmark-list">
    <li>Persönliche Daten bearbeiten</li>
    <li>Bestellungen einsehen</li>
    <li>Termine buchen und verwalten</li>
    <li>Datenschutzeinstellungen verwalten</li>
  </ul>
  <p>Bei Fragen kontaktieren Sie uns bitte per E-Mail <a href="mailto:onlinebestellung@pearle.at">onlinebestellung@pearle.at</a></p>
`

  return <Page richText={richText} />
}

export default compose(withCms(), withLayout(), withCart({ readOnly: true }))(LoginPage)
